module.exports = __webpack_public_path__ + "static/media/RoundedRect_Pink@2x.1320b09f.png";